module.exports = __webpack_public_path__ + "static/media/org-chart.78f49b02.jpg";